import { render, staticRenderFns } from "./mainbusinessPage6.vue?vue&type=template&id=b97efaa6&scoped=true&"
import script from "./mainbusinessPage6.vue?vue&type=script&lang=js&"
export * from "./mainbusinessPage6.vue?vue&type=script&lang=js&"
import style0 from "./mainbusinessPage6.vue?vue&type=style&index=0&id=b97efaa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97efaa6",
  null
  
)

export default component.exports